module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    attrs: {
      "no_back": "true",
      "settings": "systemZoom"
    }
  }, [_vm._v("esma")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px",
      "min-width": "1100px"
    }
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.device_embedded_information, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/device_embedded_information",
      "type": "button"
    }
  }, [_vm._v("機器・組込情報")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.certificate_information, _vm.permissionMode.BROWSE) == false && _vm.checkMenuUserPermission(_vm.acl.surplus_license, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/menu_certificate",
      "type": "button"
    }
  }, [_vm._v("証書")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.approval_history, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/approval_history",
      "type": "button"
    }
  }, [_vm._v("申請承認")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.inventory, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/menu_inventory",
      "type": "button"
    }
  }, [_vm._v("棚卸")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.bulk_import, _vm.permissionMode.BROWSE) == false && _vm.checkMenuUserPermission(_vm.acl.bulk_import2, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/bulk_import",
      "type": "button"
    }
  }, [_vm._v("一括取込")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.master_user_password, _vm.permissionMode.BROWSE) == false && _vm.checkMenuUserPermission(_vm.acl.master_user, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/menu_master",
      "type": "button"
    }
  }, [_vm._v("ユーザ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.master_bel_mak_sys, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/menu_configuration",
      "type": "button"
    }
  }, [_vm._v("管理・マスタ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.maintenance, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/menu_maintenance",
      "type": "button"
    }
  }, [_vm._v("\n        メンテナンス")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "font-size": "13px"
    }
  }, [(_vm.isUserIDOperationInCharge == false) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("■通知")]), _vm._v(" "), _c('p', [_vm._v("\n            ■ライセンス情報\n            "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "counters"
  }, [_c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・３ヵ月以内に有効期限が切れるライセンス　")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.certificateThatExpiresIn3Months
    }
  }), _vm._v("件\n              ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/notification_certificate/certificate_3_months",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・有効期限切れライセンス　")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.certificateExpiredLicense
    }
  }), _vm._v("件\n              ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/notification_certificate/certificate_expired",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)])])]), _c('p', [_vm._v("\n            ■未承認申請情報\n            "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "counters"
  }, [_c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・申請承認（申請中）")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.applicationApprovalPending
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/approval_history",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・申請承認（差戻）")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.applicationApprovalRejection
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/approval_history/rejected",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・一括取込（申請中）")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.bulkImportPending
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/approval_history/all",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・一括取込（差戻）")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.bulkImportRejection
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/approval_history/all/rejected",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)])])]), _vm._v(" "), (_vm.applicationApprovalInventoryPending > 0 || _vm.applicationApprovalInventoryRejection > 0) ? _c('p', [_vm._v("\n            ■棚卸情報\n            "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "counters"
  }, [(_vm.applicationApprovalInventoryPending > 0) ? _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・申請承認（申請中）")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.applicationApprovalInventoryPending
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    on: {
      "click": _vm.applicationApprovalInventoryBtn
    }
  }, [_vm._v("詳細")])])]) : _vm._e(), _vm._v(" "), (_vm.applicationApprovalInventoryRejection > 0) ? _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・申請承認（差戻）")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.applicationApprovalInventoryRejection
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    on: {
      "click": _vm.applicationApprovalInventoryRejectionBtn
    }
  }, [_vm._v("詳細")])])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isMultiCompanyAdmin) ? _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-top": "30px",
      "min-height": "200px"
    }
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("■余剰ライセンス")]), _vm._v(" "), _c('p', [_c('table', {
    staticClass: "counters"
  }, [_c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・3ヵ月以内に有効期限が切れる余剰ライセンス")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.surplusLicenseThatExpiresIn3Months
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/notification_certificate/surplus_3_months",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・有効期限切れ余剰ライセンス")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.surplusExpiredLicense
    }
  }), _vm._v("件\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/notification_certificate/surplus_expired",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('info-box', {
    attrs: {
      "title": "■ライセンス管理窓口からのご案内",
      "box_id": "home_box1"
    }
  }), _vm._v(" "), _c('info-box', {
    attrs: {
      "title": "■ e-sma操作マニュアル・フロー図",
      "box_id": "home_box2"
    }
  })], 1)])]), _vm._v(" "), _c('notice-modal', {
    attrs: {
      "tag": "processNoticeModal"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf6ffa7a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/menu.vue
// module id = 1063
// module chunks = 0